const FilledCheckCircleIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className} {...props}>
      <circle cx="8" cy="8" r="8" fill="#41D45B" />
      <path
        d="M10.5837 5.24229C10.9078 4.91924 11.433 4.91924 11.757 5.24229L11.814 5.30506C12.0797 5.62993 12.0608 6.10915 11.757 6.41201L7.39752 10.7578C7.07351 11.0808 6.54826 11.0807 6.22423 10.7578L4.24301 8.7826C3.91897 8.45955 3.91903 7.93593 4.24301 7.61288C4.51035 7.34635 4.91367 7.30014 5.22879 7.47268L5.29083 7.51025L5.29911 7.51575L5.34414 7.54874C5.35153 7.55415 5.35859 7.56037 5.36528 7.56661L5.36804 7.56936L5.39883 7.59639L5.40343 7.60051L5.41124 7.60784L6.8111 9.00344L10.5837 5.24229Z"
        fill="white"
      />
    </svg>
  );
};

export default FilledCheckCircleIcon;
